import { QueryClientConfig } from '@tanstack/vue-query'
import { hoursToMs, minutesToMs } from '@thyme/libs/src/time/convert'

const STALE_TIME_MINUTES = 2
const CATALOG_DATA_STALE_TIME_HOURS = 8

/**
 * Stale time for catalog/reference data that changes infrequently.
 * Used for global reference data like medical condition attributes, cancer diagnosis references, etc.
 */
export const CATALOG_DATA_STALE_TIME_MS = hoursToMs(
  CATALOG_DATA_STALE_TIME_HOURS
)

/**
 * Default VueQuery client configuration for Thymebox
 */
export const QUERY_CLIENT_CONFIG: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: minutesToMs(STALE_TIME_MINUTES),
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
} as const
